import '@/assets/scss/intro.scss'
import { API } from '@/api/common.js'
import {
  hasExceptionGamesFromSessionStorage,
  setExceptedGamesToSessionStorage
} from '@/utils/exceptionGame.js'
import { getBaseInfo } from '@/utils'
import { i18n } from './i18n'

const $app = document.querySelector('#app')

// 특정 상점 제외 여부 체크
setExceptedGamesToSessionStorage()

// intro view log
if (window.$h) {
  window.$h.a2s.sendContentsLog('Intro', '')
}

API({
  method: 'get',
  url: `/v2/introduce/shop`
})
  .then(({ data }) => {
    const resData = data.data
    const code = data.code

    // const strStartDateTime = resData.startDateTime
    // const strEndDateTime = resData.endDateTime
    let message = resData.message

    if (code === 201) {
      document.querySelector('.introSec02').style.display = 'none'
      document.querySelector('.introSec04').style.display = 'none'

      const app = document.querySelector('.introSec03')

      if (message) {
        message = message.replace(/\n/g, '<br />')
      }

      const html = `
          <div class="maint wrap_maintenance">
            <i></i>
            <h1>${i18n.t(
              'maintenance.currently_under_maintenance_shopping_F01'
            )}</h1>
            <p>${i18n.t(
              'maintenance.sorry_for_the_inconvenience'
            )}<br/>${i18n.t(
        'maintenance.shop_unavailable_due_to_maintenance'
      )}</p>
            ${message ? `<h2>${message}</h2>` : ''}
          </div>`
      app.innerHTML = html
    } else if (code === 0 && resData.length) {
      window.shopClickEvent = shopId => {
        window.$h.a2s.sendClickLog('Intro', JSON.stringify({ ShopID: shopId }))
      }

      const docFrag = document.createDocumentFragment(),
        $ul = document.querySelector('.introSec03 ul'),
        len = resData.length
      for (let i = 0; i < len; i++) {
        const li = document.createElement('li'),
          {
            enableHot,
            enableIntroShow,
            enableNew,
            shopId,
            shopImageUrl,
            shopName,
            appNonExposure,
            shopMaintenance
          } = resData[i]

        if (enableIntroShow === false) continue

        let state = ''

        if (shopMaintenance) {
          state = 'maintenance'
        } else {
          if (enableHot) {
            state = 'hot'
          } else if (enableNew) {
            state = 'new'
          }
        }

        if (
          hasExceptionGamesFromSessionStorage() &&
          appNonExposure !== undefined &&
          appNonExposure
        ) {
          continue
        }

        li.innerHTML = `
        <a href="/${shopId}" onclick="shopClickEvent('${shopId}')">
            <span class="shopLogo">
              <img src="${shopImageUrl}" width="100%" height="100%" alt=""></span>
            <span class="shopName">${shopName}</span>
            <span class="shopState ${state}">${
          state === 'maintenance' ? '점검중' : state.toUpperCase()
        }</span>
        </a>`
        docFrag.appendChild(li)
      }
      $ul.appendChild(docFrag)
    }
  })
  .catch(err => {
    console.log(err)
  })

const getFooterAllRightsReserved = () => {
  const { nationPath } = getBaseInfo()

  if (nationPath) {
    return nationPath === 'kr'
      ? 'ⓒ NEXON Korea Corporation All Rights Reserved.'
      : '© NEXON Korea Corporation & NEXON Co., Ltd All Rights Reserved.'
  }

  return ''
}

$app.innerHTML = `
  <div class="introWrap">
      <div class="introSec01">
        <h1 class="accessibilityHide">NEXON SHOPPING 새로운 아이템 샵. 넥슨쇼핑</h1>
      </div>
      <div class="introSec02">
        <ul>
          <li class="intro01"><p class="introText">게임에 접속하지 않아도 <br><strong>모바일로 언제나 편리하게</strong></p></li>
          <li class="intro02"><p class="introText">장바구니에 담아 <br><strong>넥슨캐시 충전없이 바로 결제</strong></p></li>
          <li class="intro03"><p class="introText">결제하면 <br><strong>MY &gt; 내쿠폰함</strong>에 쿠폰이 쏙</p></li>
        </ul>
      </div>
      <div class="introSec03">
        <h2 class="accessibilityHide2">넥슨 쇼핑 상점</h2>
        <ul></ul>
      </div>
      <div class="introSec04">
        <h2 class="accessibilityHide2">FAQ 자주묻는 질문</h2>
        <div class="faq">
          <dl>
            <dt><i class="icon"></i>구매한 아이템은 게임에 어떻게 사용하나요?</dt>
            <dd><i class="icon"></i>구매한 상품은 쿠폰으로 발행되어 MY 페이지 > 내 쿠폰함에서 확인할 수 있습니다.<br>
              구매확정하시면 쿠폰번호를 확인 할 수 있고, 각 게임의 쿠폰번호를 입력하는 곳에서 쿠폰을 입력하시면 아이템으로 수령할 수 있습니다.</dd>
          </dl>
          <dl>
            <dt><i class="icon"></i>구매 한도 제한이 있나요?</dt>
            <dd><i class="icon"></i>미성년자는 7만원 아이템 구매 한도에 포함됩니다.<br>
              쿠폰을 사용할 때 구매한도에 추가되므로 구매 한도가 부족할 경우 쿠폰 사용을 하지 못할 수 있습니다.<br>
              남은 한도를 확인하시고, 한도에 맞게 구매 해 주세요. </dd>
          </dl>
          <dl>
            <dt><i class="icon"></i>구매한 아이템 쿠폰의 유효기간은 어떻게 되나요?</dt>
            <dd><i class="icon"></i>상품마다 유효기간은 모두 다릅니다. 구매 전 꼭 유효기간을 확인하고 구매해주세요.
              구매 후에는 쿠폰함에서 유효기간을 확인할 수 있습니다. </dd>
          </dl>
          <dl>
            <dt><i class="icon"></i>청약철회 할 수 있나요?</dt>
            <dd><i class="icon"></i>구매 후 7일 이내 구매 확정하지 않았다면 청약철회 할 수 있습니다.
              내쿠폰함에서 환불할 쿠폰의 메뉴를 클릭하면 청약철회할 수 있습니다.
              구매확정 후에는 쿠폰함에서 청약철회 할 수 없으니 참고해주세요. </dd>
          </dl>
          <dl>
            <dt><i class="icon"></i>결제는 무엇으로 할 수 있나요?</dt>
            <dd><i class="icon"></i>넥슨캐시가 아닌 바로 결제를 통해 구매 할 수 있습니다. 현재는 카카오페이, 토스페이, 페이코를 이용하여 결제하실 수 있습니다. </dd>
          </dl>
          <dl>
            <dt><i class="icon"></i>PC에서도 이용할 수 있나요?</dt>
            <dd><i class="icon"></i>네. 모바일샵이긴 하지만, PC에서도 접속하시면 이용가능합니다.</dd>
          </dl>
        </div>
      </div>
      <div class="introSec05"><p>${getFooterAllRightsReserved()}</p></div>
    </div>`
